import { styled } from "@mui/material/styles";
import { Button, CircularProgress } from "@mui/material";
import {
  dangerColor,
  dangerColor10,
  darkTextColor as textColor,
  secondaryTextColor,
  primaryColor,
  primaryColor10,
  // @ts-ignore
} from "../../scss/colors.module.scss";
// @ts-ignore
import { customFontSizeNormal } from "../../scss/fonts.module.scss";

export const StyledButton = styled(Button)<{
  customColor?: "danger" | "neutralPrimary" | "neutralSecondary";
  dense?: boolean;
  hidden?: boolean;
}>(({ theme, customColor, dense, hidden }) => ({
  padding: dense ? "4px 8px" : "8px 22px",
  display: "flex",
  alignItems: "center",
  fontSize: customFontSizeNormal,
  fontWeight: "bold",
  lineHeight: "20px",
  textTransform: "none",
  color: textColor,
  width: "fit-content",
  borderColor: primaryColor,
  borderRadius: "4px",
  visibility: hidden ? "hidden" : "visible",
  "&:hover": {
    backgroundColor: primaryColor10,
  },

  // Danger variant styles
  ...(customColor === "danger" && {
    borderColor: dangerColor,
    color: dangerColor,
    "&:hover": {
      borderColor: dangerColor,
      backgroundColor: dangerColor10,
    },
  }),

  // Neutral Primary variant styles
  ...(customColor === "neutralPrimary" && {
    border: "none",
    backgroundColor: "var(--neutralPrimaryColor)",
    color: "#F5F5F5",
    "&:hover": {
      border: "none",
      backgroundColor: "var(--neutralPrimaryColor)",
      color: "#F5F5F5",
    },
    "&:disabled": {
      border: "none",
      backgroundColor: "var(--neutralPrimaryColor)",
      color: secondaryTextColor,
    },
  }),

  // Neutral Secondary variant styles
  ...(customColor === "neutralSecondary" && {
    backgroundColor: "transparent",
    border: "1px solid var(--neutralSecondaryColor)",
    color: "#1e1e1e",
    "&:hover": {
      border: "1px solid var(--neutralSecondaryColor)",
      backgroundColor: "transparent",
      color: "#1e1e1e",
    },
  }),

  "&:disabled": {
    color: secondaryTextColor,
  },

  "& .MuiButton-endIcon, & .MuiButton-startIcon": {
    color:
      // eslint-disable-next-line no-nested-ternary
      customColor === "danger"
        ? dangerColor
        : // eslint-disable-next-line no-nested-ternary
          customColor === "neutralPrimary"
          ? "#F5F5F5"
          : customColor === "neutralSecondary"
            ? "#1e1e1e"
            : primaryColor,
    "&.Mui-disabled": {
      color: secondaryTextColor,
    },
  },
}));

export const StyledCircularProgress = styled(CircularProgress)(() => ({
  color: "black !important",
}));
